<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>约课管理</Breadcrumb-item>
        <Breadcrumb-item>ClassIn临时账号</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search">
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bookClassin/list"
      :params="queryParam" :onLoading="onLoading" :onSelection="onSelection" operator=""></List>
    <ResetPassWordModal :classinAccout="formData.classinAccout" :value="resetModal" @on-close="resetModal=false"></ResetPassWordModal>
  </div>
</template>
<script>
  import ResetPassWordModal from './modal/ResetPassWordModal.vue'
  export default {
    components: {
      ResetPassWordModal
    },
    data () {
      let $constant = this.$constant
      let $moment = this.$moment
      return {
        searchLoading: false,
        reload: 0,
        resetModal: false,
        queryParam: {
        },
        formData: {
          classinAccout: null,
        },
        bookClassinStatusList: [{ code: 0, text: '未使用' }, { code: 1, text: '己使用' }, { code: 2, text: '失败' }, { code: 2, text: '禁用' }],
        title: [
          {
            title: '临时账号',
            key: 'classinAccout'
          },
          {
            title: '临时密码',
            key: 'classinPwd'
          },
          {
            title: '密码重置时间',
            align: 'center',
            render: (h, params) => {
              let classinResetTime = params.row.classinResetTime || ''
              return h('span', classinResetTime && $moment(classinResetTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '课程结束时间',
            align: 'center',
            render: (h, params) => {
              let lsnEndTime = params.row.lsnEndTime || ''
              return h('span', lsnEndTime && $moment(lsnEndTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '是否已经使用',
            align: 'center',
            render: (h, params) => {
              let status = params.row.status
              let statusEnum = $constant.getEnum(this.bookClassinStatusList, status)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '操作',
            width: 120,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('a', {on: {click: () => this.reSetPassword(params.row)}}, '重置密码')
              ])
            }
          }
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
    },
    methods: {
      reSetPassword (row) {
        let self = this
        self.formData.classinAccout = row.classinAccout
        self.resetModal = true
      },
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      onSelection (selection) {
        this.selection = selection
      },
      delAll () {
        this.$refs.dataList.delAll()
      }
    }
  }

</script>



// WEBPACK FOOTER //
// BookClassinList.vue?7915ed8e